var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import tinycolor from "tinycolor2";
export var TabbedContentStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n\n  > div.tabs {\n    display: flex;\n\n    > button {\n      color: ", ";\n      max-width: 200px;\n      padding: 11px 16px;\n      background-color: ", ";\n      border: 1px solid ", ";\n      border-top-left-radius: ", ";\n      border-top-right-radius: ", ";\n      transition: color ", " ease,\n        background-color ", " ease,\n        border-color ", " ease;\n      cursor: pointer;\n      text-transform: uppercase;\n      margin-bottom: -8px;\n      &.isActive {\n        color: ", ";\n        background-color: ", ";\n        &:hover {\n          background-color: ", ";\n        }\n      }\n      &:hover {\n        background-color: ", ";\n      }\n    }\n  }\n\n  > hr.tabs-bottom {\n    border: none;\n    border-top: 1px solid ", ";\n    margin-bottom: 36px;\n  }\n\n  > div.tab-content {\n    padding: 0;\n  }\n"], ["\n  display: block;\n\n  > div.tabs {\n    display: flex;\n\n    > button {\n      color: ", ";\n      max-width: 200px;\n      padding: 11px 16px;\n      background-color: ", ";\n      border: 1px solid ", ";\n      border-top-left-radius: ", ";\n      border-top-right-radius: ", ";\n      transition: color ", " ease,\n        background-color ", " ease,\n        border-color ", " ease;\n      cursor: pointer;\n      text-transform: uppercase;\n      margin-bottom: -8px;\n      &.isActive {\n        color: ", ";\n        background-color: ", ";\n        &:hover {\n          background-color: ",
    ";\n        }\n      }\n      &:hover {\n        background-color: ",
    ";\n      }\n    }\n  }\n\n  > hr.tabs-bottom {\n    border: none;\n    border-top: 1px solid ", ";\n    margin-bottom: 36px;\n  }\n\n  > div.tab-content {\n    padding: 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.alt.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.altSelected.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.alt.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.alt.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.alt.bg;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.buttons.alt.bg).lighten(10).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.altSelected.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.alt.bg;
});
var templateObject_1;
//# sourceMappingURL=TabbedContentStyled.js.map